/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Available_Booking_TimesInputs */

const en_admin_resource_form_available_booking_times = /** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available booking times`)
};

const de_admin_resource_form_available_booking_times = /** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Buchungszeiten`)
};

const es_admin_resource_form_available_booking_times = /** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horarios de reserva disponibles`)
};

const fr_admin_resource_form_available_booking_times = /** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heures de réservation disponibles`)
};

/** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */
const it_admin_resource_form_available_booking_times = en_admin_resource_form_available_booking_times;

/** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */
const pt_br2_admin_resource_form_available_booking_times = en_admin_resource_form_available_booking_times;

/** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */
const pl_admin_resource_form_available_booking_times = en_admin_resource_form_available_booking_times;

/** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */
const hu_admin_resource_form_available_booking_times = en_admin_resource_form_available_booking_times;

/** @type {(inputs: Admin_Resource_Form_Available_Booking_TimesInputs) => LocalizedString} */
const ro_admin_resource_form_available_booking_times = en_admin_resource_form_available_booking_times;

/**
* | output |
* | --- |
* | "Available booking times" |
*
* @param {Admin_Resource_Form_Available_Booking_TimesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_available_booking_times = /** @type {((inputs?: Admin_Resource_Form_Available_Booking_TimesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Available_Booking_TimesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_available_booking_times(inputs)
	if (locale === "de") return de_admin_resource_form_available_booking_times(inputs)
	if (locale === "es") return es_admin_resource_form_available_booking_times(inputs)
	if (locale === "fr") return fr_admin_resource_form_available_booking_times(inputs)
	if (locale === "it") return it_admin_resource_form_available_booking_times(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_available_booking_times(inputs)
	if (locale === "pl") return pl_admin_resource_form_available_booking_times(inputs)
	if (locale === "hu") return hu_admin_resource_form_available_booking_times(inputs)
	return ro_admin_resource_form_available_booking_times(inputs)
});
export { admin_resource_form_available_booking_times as "admin.resource_form.available_booking_times" }